/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2109
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.BlockVisibility = undefined;
(function (e) {
  e.VISIBLE = "visible"
  e.HIDDEN = "hidden"
  e.TRANSLUCENT = "translucent"
})(exports.BlockVisibility || (exports.BlockVisibility = {}))
